const id_master_tnc_setting = {
    "": "kebijakan dan ketentuan",

    field: {
        PPN: "PPN",
        PWP: "harga termasuk PPN",
        KSPOOUT: "kepala surat PO keluar",
        RCUST: "retur pelanggan (kembali ke gudang tertentu)",
        VA: "virtual account",
        TOCPO: "syarat & ketentuan purchase order",
        TOCPLPO: "syarat & ketentuan packaging list purchase order",
        TOCSO: "syarat & ketentuan sales order",
        TOCPLSO: "syarat & ketentuan packaging list sales order",
        TOCINV: "syarat & ketentuan tagihan",
        TPO: "template purchase order",
        TSO: "template SO",
        TDO: "template DO",
        TINV: "template tagihan",
        PRODWH: "gudang tujuan produksi"
    },

    error: {
        edit: "Gagal mengubah kebijakan dan ketentuan.",
    },

    success: {
        edit: "Berhasil mengubah kebijakan dan ketentuan.",
    },
}

export default id_master_tnc_setting;